export enum CustomVjsComponentNames {
  qualityLevelsItem = "QualityLevelsItem",
  qualityLevelsMenu = "QualityLevelsMenu",
  settingsMenuItem = "SettingsMenuItem",
  controlButton = "ControlButton",
}
